import React from 'react'
import { useLocation } from 'react-router-dom'
import { AdminHealthScoreTable } from '../../components/AdminHealthScoreTable'
import AdminPageHeader from '../../components/admin/shared/AdminPageHeader'

const HealthScores: React.FC = () => {
  const location = useLocation()
  const regionFilter = new URLSearchParams(location.search).get('region')

  return (
    <>
      <AdminPageHeader pageKey="healthScores" />
      <AdminHealthScoreTable
        initialMarketFilter={regionFilter ? regionFilter.toUpperCase() : ''}
      />
    </>
  )
}

export default HealthScores
